import { useState, createContext, useContext } from 'react';
import { jsx } from '@emotion/react/jsx-runtime';

const AddressValuesContext = /*#__PURE__*/createContext(undefined);
const AddressValuesProvider = _ref => {
  let {
    children
  } = _ref;
  const [country, setCountry] = useState(null);
  const [postalCode, setPostalCode] = useState(null);
  return jsx(AddressValuesContext.Provider, {
    value: {
      selectedCountry: country,
      selectedPostalCode: postalCode,
      setSelectedCountry: country => setCountry(country),
      setSelectedPostalCode: postalCode => setPostalCode(postalCode)
    },
    children: children
  });
};
function useAddressValues() {
  const context = useContext(AddressValuesContext);
  if (context === undefined) {
    throw new Error('useDisabledFields must be used within a DisabledFieldsProvider');
  }
  return context;
}

export { AddressValuesProvider, useAddressValues };
//# sourceMappingURL=addressValues.js.map
